var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-video-player abs"},[_c('div',{staticClass:"overlay abs",on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{staticClass:"video-player"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }